<template>
  <v-container
    class="fill-height"
    fluid>
    <v-row
      align="center"
      justify="center">
      <v-col
        cols="12"
        sm="10"
        md="6">
        <v-card class="elevation-12">
          <v-toolbar
            color="primary"
            dark
            flat>
            <v-toolbar-title>Your stories</v-toolbar-title>
            <v-spacer />
          </v-toolbar>
          <v-card-text>
            <div>User: {{currentUser.displayName}}</div>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="64">ID</th>
                    <th class="text-left">Name</th>
                    <th class="text-left" width="128"></th>
                  </tr>
                </thead>
                <tbody v-if="stories.length > 0">
                  <tr v-for="story in stories" v-bind:key="story.data().uid">
                    <td>{{story.id}}</td>
                    <td><b>{{story.get('name')}}</b></td>
                    <td>
                      <v-btn text small color="primary" @click="open(story)">Open</v-btn>
                      <v-btn icon small color="red" @click="del(story)"><v-icon>delete</v-icon></v-btn>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr v-for="value in [0, 1, 2]" v-bind:key="value">
                    <td><v-skeleton-loader type="table-cell" /></td>
                    <td><v-skeleton-loader type="table-cell" /></td>
                    <td><v-skeleton-loader type="button" /></td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" text @click="newStory">New</v-btn>
            <v-spacer />
            <v-btn color="primary" text @click="logout">Logout</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'

const fb = require('../../firebaseConfig.js')

export default {
  name: 'MyStories',
  props: {
    msg: String
  },
  data: function() {
    return {
      stories: []      
    }
  },
  computed: {
    ...mapState(['currentUser']),
  },
  created: function() {
    this.loadData()
  },
  methods: {
    loadData() {
      console.log('created')
      var me = this
      fb.storiesCollection.where('owner', '==', this.$store.state.currentUser.uid)
        .get()
        .then(function(querySnapshot) {
          console.log('retrieved', querySnapshot.docs)
          me.stories = querySnapshot.docs
        })
        .catch(function(error) {
          console.log(error)
        })
    },
    open(story) {
      var storyData = story.data()
      storyData.id = story.id
      
      this.$store.dispatch('openStory', storyData)
      this.$router.push('/editor')
    },
    del(story) {
      fb.storiesCollection.doc(story.id)
        .delete()
        .then(() => {
          this.loadData()
        })
        .catch(error => {
          console.log("error deleting story", error)
        })
    },
    newStory() {
      this.$store.dispatch('createNewStory')
      this.$router.push('/editor')
    },
    logout() {
      fb.auth.signOut().then(() => {
          this.$store.dispatch('clearData')
          this.$router.push('/login')
      }).catch(err => {
        console.log(err)
      })
    },
  }
}
</script>

<style scoped>

</style>
